import { RouteLocationRaw } from "vue-router"

import { FilterSprintExtended } from "@/models/Filter/FilterSprint"
import { Actions, Getters, store } from "@/store"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  const projectId = store.getters[Getters.GET_SESSION_PROJECT_ID]
  const filter = new FilterSprintExtended({
    includeMetrics: true,
    includedStatuses: ["STARTED", "NOT_STARTED"],
    projectId
  })
  const sprints = await store.dispatch(Actions.SPRINTS_WITH_STATS_EXTENDED, { filter })
  if (!sprints.length) {
    return next({
      name: "allSprints",
      params: to.params
    })
  }
  if (sprints.length === 1) {
    // if we have one active sprint - go to that Active Sprint Overview
    return next({
      name: "sprint",
      params: {
        accountId: to.params.accountId,
        projectId: to.params.projectId,
        teamId: sprints[0].sprint.team.urlName,
        sprintId: sprints[0].sprint.sequenceNumber
      }
    })
  }
  next()
}
